import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import Routes from './routes';

import * as serviceWorker from "./serviceWorker";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core'

require('dotenv').config()

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#016481",
    }
  },
});

const App = () => <Routes />;

const render = () => {

  ReactDOM.render(
      <MuiThemeProvider theme={theme}>
          <App />
      </MuiThemeProvider>,
    document.getElementById("root")
  );
}

render()

// if (process.env.NODE_ENV === 'development' && module.hot) {
//   module.hot.accept('./app/App', render)
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
